import { GOVERNMENT_HELP_ARTICLES } from "@/lib/government-help/articles";
import { createHelpArticleSearch } from "@/lib/help-search";

export const searchGovernmentHelpArticles = createHelpArticleSearch(
  GOVERNMENT_HELP_ARTICLES,
);
